import { render, staticRenderFns } from "./EditWorkHours.vue?vue&type=template&id=1801d786&"
import script from "./EditWorkHours.vue?vue&type=script&lang=js&"
export * from "./EditWorkHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports